import React from "react"
import leftQuote from "../img/left-quote.png"

const QuoteBox = ({ body, name }) => {
  return (
    <div className="box has-background-primary" style={{ marginBottom: 16 }}>
      <div className="columns">
        <div className="column is-narrow">
          <img src={leftQuote} alt="Quote Graphic" style={{ width: 100 }} />
        </div>
        <div className="column">
          <p
            className="has-text-white has-text-weight-bold is-size-5-mobile is-size-4-tablet is-size-3-widescreen"
            style={{ marginBottom: 0 }}
          >
            {body}
          </p>
          <span>
            <em className="has-text-white">{name}</em>
          </span>
        </div>
      </div>
    </div>
  )
}

export default QuoteBox
